function emptyInputAndFocus(formEl, inputName) {
    const input = formEl.elements[inputName];
    input.value = '';
    input.focus();
}

export { emptyInputAndFocus };
